@if (ready() && view(); as v) {
  <div class="op-shell">
    <div
      class="op-card op-card--prize-box"
      [class.op-card--pattern]="!!v.patternCss"
      [class.op-card--intro]="v.layout === 'challenge_intro'"
      [style.background]="v.background"
      [style.color]="v.textColor"
      [style.--op-pattern]="v.patternCss || 'none'"
      [style.--op-banner-fg]="v.bannerTextColor"
      [style.--op-header-plate]="v.headerIconBackground"
      [style.--op-banner-bg]="v.bannerBackground"
      [style.--op-cta-bg]="v.ctaBackground"
      [style.--op-cta-fg]="v.ctaTextColor"
      [style.--op-cta-shadow]="v.ctaShadowColor">
      @if (v.headerIcon) {
        <div
          class="op-header op-header--plate"
          [style.background]="v.headerIconBackground">
          <img class="op-header-icon" [src]="v.headerIcon" alt="" />
        </div>
      }

      @if (v.title) {
        <h2 class="op-title">{{ v.title }}</h2>
      }

      <div
        class="op-banner"
        [style.background]="v.bannerBackground"
        [style.color]="v.bannerTextColor">
        @if (v.bannerIcon) {
          <img class="op-banner-icon" [src]="v.bannerIcon" alt="" />
        }
        <div class="op-banner-copy">
          @if (v.prizeLabel) {
            <div class="op-banner-label">{{ v.prizeLabel }}</div>
          }
          @if (lines().prize_value) {
            <div
              class="op-banner-value"
              [innerHTML]="lines().prize_value | safeHtml"></div>
          }
        </div>
      </div>

      <div class="op-panel" [style.background]="v.panelColor">
        <div class="op-row">
          @if (v.rowIcons?.[0]) {
            <img class="op-row-icon" [src]="v.rowIcons[0]" alt="" />
          }
          <p [innerHTML]="lines().line_1 | safeHtml"></p>
        </div>
        <div class="op-row">
          @if (v.rowIcons?.[1]) {
            <img class="op-row-icon" [src]="v.rowIcons[1]" alt="" />
          }
          <p [innerHTML]="lines().line_2 | safeHtml"></p>
        </div>
        @if (lines().line_3) {
          <div class="op-row">
            @if (v.rowIcons?.[2]) {
              <img class="op-row-icon" [src]="v.rowIcons[2]" alt="" />
            }
            <p [innerHTML]="lines().line_3 | safeHtml"></p>
          </div>
        }
      </div>

      @if (v.showCta) {
        <button
          type="button"
          class="op-cta"
          [class.op-cta--pressed]="ctaPressed()"
          (pointerdown)="pressCta()"
          (click)="close('cta')">
          {{ v.ctaText }}
        </button>
      }
    </div>
  </div>
}
